import axios from "../Axios/Default"; //url backend
import { handleResponse } from "../Utils/Utils"; //handle response

const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const authUser = (payload, onSuccess, onError) => {
  const response = axios.post("login", payload, config);
  return handleResponse(response, onSuccess, onError);
};

export const authUserSSO = (payload, onSuccess, onError) => {
  const response = axios.post("sso-login", payload, config);
  return handleResponse(response, onSuccess, onError);
}
